<template>
	<!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：门店-店员列表-添加店员
    -->
	<div class="product-add">
		<!--form表单-->
		<el-form size="small" ref="form" :model="form" label-width="200px">
			<!--添加店员-->
			<div class="common-form">添加商户</div>
			<el-form-item label="商户名称" prop="supplier.name" :rules="[{ required: true, message: ' ' }]">
				<el-input class="max-w460" v-model="form.supplier.name" placeholder="请输入商户名称"></el-input>
			</el-form-item>
			<el-form-item label="账号" prop="supplier.userName" :rules="[{ required: true, message: ' ' }]">
				<el-input class="max-w460" v-model="form.supplier.userName" placeholder="请输入账号"></el-input>
			</el-form-item>
			<el-form-item label="登录密码" prop="supplier.password" :rules="[{ required: true, message: ' ' }]">
				<el-input v-model="form.supplier.password" placeholder="请输入登录密码" :type="flag?'password':''"
					class="max-w460">
					<template slot="append">
						<i slot="suffix" :class="[flag ? 'fa fa-eye-slash' : 'el-icon-view']" autocomplete="auto"
							@click="flag = !flag" />

					</template>
				</el-input>
			</el-form-item>
			<el-form-item label="确认密码" prop="supplier.confirm_password" :rules="[{ required: true, message: ' ' }]">
				<el-input v-model="form.supplier.confirm_password" placeholder="请输入确认密码" class="max-w460"
					:type="flag1?'password':''">
					<template slot="append">
						<i slot="suffix" :class="[flag1 ? 'fa fa-eye-slash' : 'el-icon-view']" autocomplete="auto"
							@click="flag1 = !flag1" />
					</template>
				</el-input>
			</el-form-item>
			<el-form-item label="联系人" prop="supplier.linkName" :rules="[{ required: true, message: ' ' }]">
				<el-input class="max-w460" v-model="form.supplier.linkName" placeholder="请输入联系人"></el-input>
			</el-form-item>
			<el-form-item label="联系电话" prop="supplier.linkPhone" :rules="[{ required: true, message: ' ' }]">
				<el-input class="max-w460" v-model="form.supplier.linkPhone" placeholder="请输入联系电话"></el-input>
			</el-form-item>
			<el-form-item label="门店logo">
				<el-row>
					<el-button icon="el-icon-picture-outline" @click="openUpload('logo')">选择图片</el-button>
					<div v-if="form.supplier.logoId != ''" class="img">
						<img :src="logo_filePath" width="100" height="100" />
					</div>
				</el-row>
			</el-form-item>
			<!-- <el-form-item label="是否支持到店">
				<el-radio-group v-model="form.supplier.isStore">
					<el-radio :label="1">支持</el-radio>
					<el-radio :label="2">不支持</el-radio>
				</el-radio-group>
			</el-form-item> -->
			<el-form-item label="抽成比例" prop="supplier.scale" :rules="[{ required: true, message: ' ' }]">
				<el-input v-model="form.supplier.scale" placeholder="请输入抽成比例，如10" type="number"
					class="max-w460"></el-input>
			</el-form-item>
			<el-form-item label="服务类型" :rules="[{ required: true, message: ' ' }]">
				<el-select v-model="serviceIdList" placeholder="请选择" multiple>
					<el-option v-for="(item, index) in serviceType" :key="index" :label="item.name"
						:value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="城市" prop="supplier.serviceCityId" :rules="[{ required: true, message: ' ' }]">
				<el-select v-model="form.supplier.serviceCityId" placeholder="请选择">
					<el-option v-for="(item, index) in citydata" :key="index" :label="item.city"
						:value="item.serviceCityId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="店铺状态">
			  <el-radio-group v-model="form.supplier.isRecycle">
			    <el-radio :label="0">开启</el-radio>
			    <el-radio :label="1">禁用</el-radio>
			  </el-radio-group>
			</el-form-item>
			<el-form-item label="选择位置" prop="">
			  <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc" style="width:80%"></Getpoint>
			</el-form-item>
			<el-form-item label="详细地址" prop="supplier.address">
			  <el-input disabled v-model="form.supplier.address" placeholder="请输入详细地址" class="max-w460"></el-input>
			</el-form-item>
			<el-form-item label="经度">
			  <el-input class="max-w460" v-model="form.supplier.lng" disabled></el-input>
			</el-form-item>
			<el-form-item label="纬度">
			  <el-input class="max-w460" v-model="form.supplier.lat" disabled></el-input>
			</el-form-item>
			<el-form-item label="营业执照">
				<el-row>
					<el-button icon="el-icon-picture-outline" @click="openUpload('business')">选择图片</el-button>
					<div v-if="form.supplier.businessId != ''" class="img">
						<img :src="business_filePath" width="100" height="100" />
					</div>
				</el-row>
			</el-form-item>
			<!-- <el-form-item label="绑定用户">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="userClick()">选择用户</el-button>
          <div v-if="form.supplier.userId != 0" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item> -->
			<el-form-item label="商家介绍" prop="supplier.description">
				<el-input type="textarea" v-model="form.supplier.description" class="max-w460"></el-input>
			</el-form-item>
			<!--提交-->
			<div class="common-button-wrapper">
				<el-button size="small" type="info" @click="cancelFunc">取消</el-button>
				<el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
			</div>
		</el-form>

		<!--上传图片组件-->
		<Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
		<!--管理用户-->
		<GetUser :is_open="open_user" @close="closeDialogFunc($event, 'add')"></GetUser>
	</div>
</template>

<script>
	import SupplierApi from "@/api/supplier.js";
	import Upload from "@/components/file/Upload";
	import GetUser from "@/components/user/GetUser.vue";
	import Getpoint from "@/components/map/Getpoint.vue";
	export default {
		components: {
			/*上传组件*/
			Upload,
			/*选择用户*/
			GetUser,
			Getpoint
		},
		data() {
			return {
				/*form表单数据*/
				/*左边长度*/
				formLabelWidth: "180px",
				form: {
					supplier: {
						logoId: 0,
						businessId: 0,
						openService: 0,
						categoryId: "",
						userId: 0,
						storeType: 10,
						serviceCityId: "",
						isStore: 2,
						isRecycle: 0,
						address: "",
						lng: "",
						lat: "",
					}
				},
				flag: true,
				flag1: true,
				logo_filePath: "",
				business_filePath: "",
				/*是否打开添加弹窗*/
				open_add: false,
				storeList: [],
				category: [],
				citydata: [],
				serviceType: [],
				/*是否上传图片*/
				isupload: false,
				loading: false,
				type: "logo",
				open_user: false,
				user_info: {},
				serviceIdList:[]
			};
		},
		created() {
			/*获取列表*/
			this.getCategoryList();
		},
		methods: {
			  /*获取经纬度*/
			  getMapdataFunc(e) {
			    console.log("获取经纬度", e);
			    this.form.lng = e.data[0].toFixed(6);
			    this.form.lat = e.data[1].toFixed(6);
			    // this.form.coordinate =
			    //   e.data[0].toFixed(6) + "," + e.data[1].toFixed(6);
			  },
			
			  /*选择的地址*/
			  choseFunc(e) {
			    console.log("获取经纬度2", e);
			    this.form.supplier.lng = e.location.lng;
			    this.form.supplier.lat = e.location.lat;
			    this.form.supplier.address = e.address;
			  },
			/*获取类别*/
			getCategoryList() {
				let self = this;
				let Params = {};

				SupplierApi.toaddSupplier(Params, true)
					.then(res => {
						self.citydata = res.data.data;
						self.serviceType = res.data.serviceType;
						if (self.category.length > 0) {
							self.form.categoryId = self.category[0].categoryId;
						}
					})
					.catch(error => {});
			},
			onSubmit() {
				let self = this;
				let serviceIds = "";
				if (self.serviceIdList.length > 0) {
					serviceIds = self.serviceIdList.join(",");
				} else {
					serviceIds = "";
				}

				if (self.form.supplier.password != self.form.supplier.confirm_password) {
					return self.$message({
						message: "密码输入不一致，请重新输入",
						type: "error"
					});
				}
				let form = self.form.supplier;
				form.serviceIds = serviceIds;
				self.$refs.form.validate(valid => {
					if (valid) {
						self.loading = true;
						SupplierApi.addSupplier(form, true)
							.then(data => {
								self.loading = false;
								if (data.code == 1) {
									self.$message({
										message: "恭喜你，商户添加成功",
										type: "success"
									});
									self.$router.push("/supplier/supplier/index");
								} else {
									self.loading = false;
								}
							})
							.catch(error => {
								self.loading = false;
							});
					}
				});
			},

			/*上传*/
			openUpload(e) {
				this.type = e;
				this.isupload = true;
			},

			/*获取图片*/
			returnImgsFunc(e) {
				if (e != null && e.length > 0) {
					if (this.type == "logo") {
						this.logo_filePath = e[0].filePath;
						this.form.supplier.logoId = e[0].fileId;
					} else if (this.type == "business") {
						this.business_filePath = e[0].filePath;
						this.form.supplier.businessId = e[0].fileId;
					}
				}
				this.isupload = false;
			},

			/*取消*/
			cancelFunc() {
				this.$router.back(-1);
			},
			/*打开弹出层*/
			userClick() {
				this.open_user = true;
			},

			/*关闭获取用户弹窗*/
			closeDialogFunc(e) {
				if (e.type != "error") {
					this.user_info = e.params[0];
					this.form.supplier.userId = e.params[0].userId;
				}
				this.open_user = false;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.basic-setting-content {}

	.product-add {
		padding-bottom: 50px;
	}

	.img {
		margin-top: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/views/supplier/supplier/add.vue